import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const timeTrackingRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/time-tracking",
  component: lazyRouteComponent(() => import("./time-tracking.page.js"), "TimeTrackingPage"),
});
